module.exports = __webpack_public_path__ + "static/media/lumin-black-and-green-bottles-on-stones.8fa67141.jpg";